import axios from 'axios';
// import { GraphURL } from '../config/app';
import { onWaiting } from './Actions';
import Alert from 'react-s-alert';

class Graph {
    constructor() {
        this.instance = axios.create({
            baseURL:  process.env.REACT_APP_GRAPH_END_POINT,
            timeout: 30000,
            transformRequest: this.transform,
            headers: {}
        })
    }

    getToken() {
        let token = sessionStorage.getItem('token');
        if(!token) return false;

        return token;
    }
    
    get(uri,params, dispatch) {
        return this.instance.get(`/graphql${uri}?query=${params}`, {
            params: {
                token: this.getToken(),
                ...params
            }
        })
        .then(response => {
            const { data } = response
            return data;
        })
        .catch(err => {
            const { data, status } = err;

            if([401,400].indexOf(status) >= 0){
                Alert.error(data.data.message)
            }
            dispatch(onWaiting(false))
            return false;
        })

    }

    transform(object) {
        let arr = [];
        for(let p in object) {
            if(object.hasOwnProperty(p)) {
                arr.push(encodeURIComponent(p) + "=" + encodeURIComponent(object[p]))
            }
        }

        return arr.join("&");
    }
}

// eslint-disable-next-line
export default new Graph();


// WEBPACK FOOTER //
// ./src/Graph.js